@if (employeeListService.loading()) {
  <div class="py-1 client-skeleton-wrapper">
    <bai-client-info-skeleton *ngFor="let i of [1, 2, 3, 4, 5, 6]" />
    <div class="fade-gradient-overlay"></div>
  </div>
} @else {
  <div class="flex flex-col h-full">
    <div>
      @if (collapsed) {
        <ng-container *ngTemplateOutlet="conversationList; context: {
        $implicit: employeeListService.sessions(),
        scrollHeight: 'calc(100vh - 133px - .5rem)'
      }"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="conversationList; context: {
        $implicit: employeeListService.sessions(),
        scrollHeight: 'calc(100vh - 170px - .5rem)'
      }"></ng-container>
      }
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-center border-t-2 border-gray-200 pt-2">
      <button (click)="routeTo()">
        <i
          class="pi pi-home mr-2"
          aria-label="Return to My Clients"
          [pTooltip]="collapsed ? 'Return to My Clients' : undefined"
          tooltipPosition="top"
        ></i>
        @if (!collapsed) {Return to My Clients}
      </button>
    </div>
  </div>
}
<ng-template #conversationList let-conversations let-scrollHeight="scrollHeight">
  @if (!collapsed) {
    <div class="py-2 px-2 text-sm font-medium text-gray-600">
      @if (employeeSearchService.activeEmployee()?.firstName) {
        {{ employeeSearchService.activeEmployee()?.firstName }} {{ employeeSearchService.activeEmployee()?.lastName }}'s Conversations
      } @else {
        Employee Conversations
      }
    </div>
  }
  <p-scrollPanel styleClass="pb-2" [style]="{ height: scrollHeight }">
    @if (conversations.length > 0) {
      <ng-container *ngFor="let conversation of conversations">
        <div
          [attr.data-conversation]="conversation.conversationId"
          tabindex="-1"
          style="margin-bottom: .5rem"
        >
          <lib-conversation-info
            [conversationInfo]="conversation"
            [selected]="conversation.conversationId === employeeListService.activeConversation()?.conversationId"
            [collapsed]="collapsed"
            [type]="'employee'"
            (conversationClicked)="conversationSelected($event)"
          />
        </div>
      </ng-container>
    } @else if (!collapsed) {
      <div class="flex items-center justify-center">
        @if (employeeSearchService.activeEmployee()) {
          {{ employeeSearchService.activeEmployee()?.firstName }} doesn't have any conversations
        } @else {
          Please search for an employee.
        }
      </div>
    }
  </p-scrollPanel>
</ng-template>
